<ng-template #content>
  <ng-content></ng-content>
</ng-template>

@if (form) {
  @switch (type) {
    @case ('BOOLEAN') {
      <ax-boolean-edit
        [form]="form"
        [name]="name"
        [label]="label"
        [floatLabel]="floatLabel"
        [placeholder]="placeholder"
        [icon]="icon"
        [hint]="hint"
        [autofocus]="autofocus"
        [required]="required"
        [autocompleteAttr]="autocompleteAttr"
        [errorsTemplate]="errorsTemplate"
        [readonly]="readonly"
      >
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </ax-boolean-edit>
    }
    @case ('TEXT_AREA') {
      <ax-textarea-edit
        [form]="form"
        [name]="name"
        [label]="label"
        [floatLabel]="floatLabel"
        [placeholder]="placeholder"
        [icon]="icon"
        [hint]="hint"
        [autofocus]="autofocus"
        [required]="required"
        [matAutocomplete]="matAutocomplete"
        [autocompleteAttr]="autocompleteAttr"
        [errorsTemplate]="errorsTemplate"
        [readonly]="readonly"
        (focused)="focused.emit()"
      >
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </ax-textarea-edit>
    }
    @case ('URL') {
      <ax-url-edit
        [form]="form"
        [name]="name"
        [label]="label"
        [floatLabel]="floatLabel"
        [placeholder]="placeholder"
        [icon]="icon"
        [hint]="hint"
        [autofocus]="autofocus"
        [required]="required"
        [matAutocomplete]="matAutocomplete"
        [autocompleteAttr]="autocompleteAttr"
        [errorsTemplate]="errorsTemplate"
        [readonly]="readonly"
        [enableValidation]="enableValidation"
        [prefix]="prefix"
        (focused)="focused.emit()"
      >
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </ax-url-edit>
    }
    @case ('PHONE') {
      <ax-phone-edit
        [form]="form"
        [name]="name"
        [label]="label"
        [floatLabel]="floatLabel"
        [placeholder]="placeholder"
        [icon]="icon"
        [hint]="hint"
        [autofocus]="autofocus"
        [required]="required"
        [matAutocomplete]="matAutocomplete"
        [autocompleteAttr]="autocompleteAttr"
        [errorsTemplate]="errorsTemplate"
        [readonly]="readonly"
        (focused)="focused.emit()"
      >
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </ax-phone-edit>
    }
    @case ('RICH_TEXT') {
      <ax-rich-text-edit
        [form]="form"
        [name]="name"
        [label]="label"
        [floatLabel]="floatLabel"
        [placeholder]="placeholder"
        [icon]="icon"
        [hint]="hint"
        [autofocus]="autofocus"
        [required]="required"
        [matAutocomplete]="matAutocomplete"
        [autocompleteAttr]="autocompleteAttr"
        [errorsTemplate]="errorsTemplate"
        [readonly]="readonly"
        (quillEditorChange)="quillEditorCreated($event)"
        (focused)="focused.emit()"
      >
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </ax-rich-text-edit>
    }
    @case ('DATE') {
      <ax-date-edit
        [form]="form"
        [name]="name"
        [label]="label"
        [floatLabel]="floatLabel"
        [placeholder]="placeholder"
        [icon]="icon"
        [hint]="hint"
        [autofocus]="autofocus"
        [required]="required"
        [matAutocomplete]="matAutocomplete"
        [autocompleteAttr]="autocompleteAttr"
        [errorsTemplate]="errorsTemplate"
        [readonly]="readonly"
        (focused)="focused.emit()"
      >
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </ax-date-edit>
    }
    @case ('EMAIL') {
      <ax-email-edit
        [form]="form"
        [name]="name"
        [label]="label"
        [floatLabel]="floatLabel"
        [placeholder]="placeholder"
        [icon]="icon"
        [hint]="hint"
        [autofocus]="autofocus"
        [required]="required"
        [matAutocomplete]="matAutocomplete"
        [autocompleteAttr]="autocompleteAttr"
        [errorsTemplate]="errorsTemplate"
        [prefix]="prefix"
        [postfix]="postfix"
        [readonly]="readonly"
        (focused)="focused.emit()"
      >
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </ax-email-edit>
    }
    @default {
      @if (readonly) {
        <ax-textarea-edit
          [form]="form"
          [name]="name"
          [label]="label"
          [floatLabel]="floatLabel"
          [placeholder]="placeholder"
          [icon]="icon"
          [hint]="hint"
          [autofocus]="autofocus"
          [required]="required"
          [matAutocomplete]="matAutocomplete"
          [autocompleteAttr]="autocompleteAttr"
          [errorsTemplate]="errorsTemplate"
          [readonly]="readonly"
          (focused)="focused.emit()"
        >
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </ax-textarea-edit>
      } @else {
        <ax-text-edit
          [inputType]="inputType || 'text'"
          [numberConfig]="numberConfig"
          [form]="form"
          [name]="name"
          [label]="label"
          [floatLabel]="floatLabel"
          [placeholder]="placeholder"
          [icon]="icon"
          [hint]="hint"
          [autofocus]="autofocus"
          [required]="required"
          [matAutocomplete]="matAutocomplete"
          [autocompleteAttr]="autocompleteAttr"
          [errorsTemplate]="errorsTemplate"
          [prefix]="prefix"
          [postfix]="postfix"
          [readonly]="readonly"
          (focused)="focused.emit()"
        >
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </ax-text-edit>
      }
    }
  }
} @else {
  <div class="loading">&nbsp;</div>
}
